/**
 * SPDentaire opens the in-office signature page with `tablet=1`.
 * Patient links (SMS, QR) omit it. The flag is read from the real query
 * string and from a query string carried inside the hash, so BrowserRouter
 * (`/{id}?tablet=1`) and HashRouter (`/#/{id}?tablet=1` or `/?tablet=1#/{id}`)
 * both work. The session id stays in the route path and is not parsed here.
 */
export function isTabletCaptureRequested(locationLike: {
  search?: string
  hash?: string
}): boolean {
  if (queryHasTabletFlag(locationLike.search || '')) return true
  return queryHasTabletFlag(queryFromHash(locationLike.hash || ''))
}

function queryFromHash(hash: string): string {
  const index = hash.indexOf('?')
  if (index < 0) return ''
  return hash.slice(index)
}

function queryHasTabletFlag(search: string): boolean {
  if (!search) return false
  const query = search.startsWith('?') ? search.slice(1) : search
  return new URLSearchParams(query).get('tablet') === '1'
}
